import React from "react";

import { Ico } from "./malluIcons";
import { MalluLockup } from "./malluMark";

const ACTION_ICONS = ["pix", "barcode", "receive", "card"];
const TX_ICONS = ["pix", "card", "globe"];

const asList = (value) => (Array.isArray(value) ? value : []);

/**
 * Tela inicial do app Mallu Pay (mock), usada dentro do IosDevice no hero e
 * nas páginas internas. `t` deve vir do namespace "malluLanding";
 * `balanceRef` é opcional (count-up do saldo no hero).
 */
export const MalluAppScreen = ({ t, balanceRef }) => {
  const actions = asList(t("hero.phone.actions", { returnObjects: true }));
  const txs = asList(t("hero.phone.tx", { returnObjects: true }));

  return (
    <div className="pp-app">
      <div className="pp-app-top">
        <MalluLockup />
        <div className="pp-app-bell">
          <Ico name="bell" size={20} />
        </div>
      </div>
      <div className="pp-app-hello">{t("hero.phone.greeting")}</div>
      <div className="pp-app-tag">{t("hero.phone.tagline")}</div>
      <div className="pp-app-actions">
        {actions.map((label, i) => (
          <div className="pp-app-action" key={label}>
            <Ico name={ACTION_ICONS[i] || "pix"} size={22} color="#ff68b5" />
            <span>{label}</span>
          </div>
        ))}
      </div>
      <div className="pp-app-balance">
        <div className="pp-app-balance-head">
          <span>{t("hero.phone.balanceLabel")}</span>
          <Ico name="arrow" size={20} />
        </div>
        <div className="pp-app-balance-row">
          <span ref={balanceRef} className="pp-app-balance-val">
            {t("hero.phone.balance")}
          </span>
          <Ico name="eye" size={20} color="rgba(255,255,255,.75)" />
        </div>
      </div>
      <div className="pp-app-label">{t("hero.phone.movements")}</div>
      <div className="pp-app-list">
        {txs.map((tx, i) => (
          <div className="pp-app-tx" key={tx.title}>
            <div className={`pp-app-tx-ico${i === 0 ? " pp-app-tx-ico--cyan" : ""}`}>
              <Ico
                name={TX_ICONS[i] || "pix"}
                size={18}
                color={i === 0 ? "#ff68b5" : "#d9d3ea"}
                sw={2}
              />
            </div>
            <div className="pp-app-tx-body">
              <div className="pp-app-tx-title">{tx.title}</div>
              <div className="pp-app-tx-meta">{tx.meta}</div>
            </div>
            <div className={`pp-app-tx-amt${i === 0 ? " pp-app-tx-amt--in" : ""}`}>
              {tx.amount}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
